"use strict";

function isFiniteNumber(value, entity = "Value", ErrorClass = TypeError) {
  if (typeof value !== "number" || Number.isNaN(value)) {
    throw new ErrorClass(`${entity} is not a number: ${value}`);
  }
  if (!Number.isFinite(value)) {
    throw new ErrorClass(`${entity} is not a finite number: ${value}`);
  }
}
function isInt(value, entity = "Value", ErrorClass = TypeError) {
  isFiniteNumber(value, entity, ErrorClass);
  if (!Number.isInteger(value)) {
    throw new ErrorClass(`${entity} is not an integer: ${value}`);
  }
  if (!Number.isSafeInteger(value)) {
    throw new ErrorClass(`${entity} is not a safe integer: ${value}`);
  }
}
function isFloat(value, entity = "Value", ErrorClass = TypeError) {
  isFiniteNumber(value, entity, ErrorClass);
}
function toFixedRate(rate, scale, asNumber) {
  isFloat(rate, "Rate");
  const fixedRate = rate.toFixed(scale);
  return asNumber ? +fixedRate : fixedRate;
}
const numberToString = num => {
  isFloat(num);
  return num.toString(10);
};
const findClosestNumber = (haystack, needle) => {
  return haystack.reduce((prev, curr) => Math.abs(curr - needle) < Math.abs(prev - needle) ? curr : prev);
};
const splitNumberBy = (value, by) => {
  const chunks = new Array(Math.floor(value / by)).fill(by);
  const remainder = value % by;
  if (remainder > 0) {
    chunks.push(remainder);
  }
  return chunks;
};
const clamp = (val, min, max) => {
  const trueMin = Math.min(min, max);
  const trueMax = Math.max(min, max);
  return Math.min(trueMax, Math.max(trueMin, val));
};
const linearInterpolate = (inputY, [fromMin, fromMax], [toMin, toMax], clampResult = true) => {
  const percent = (inputY - fromMin) / (fromMax - fromMin);
  const outputX = percent * (toMax - toMin) + toMin;
  return clampResult ? clamp(outputX, toMin, toMax) : outputX;
};
const incrementLoopValue = (value, [min, max]) => {
  if (value === max) {
    return min;
  }
  return value + 1;
};
export { clamp, findClosestNumber, incrementLoopValue, isFiniteNumber, isFloat, isInt, linearInterpolate, numberToString, splitNumberBy, toFixedRate };
//# sourceMappingURL=number.mjs.map
